

'use strict';
var availableCountries=["Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegowina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, the Democratic Republic of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia (Hrvatska)", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "France Metropolitan", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard and Mc Donald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan", "Lao, People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia, The Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman","Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Seychelles", "Sierra Leone", "Singapore", "Slovakia (Slovak Republic)", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "St. Helena", "St. Pierre and Miquelon", "Sudan", "Suriname", "Svalbard and Jan Mayen Islands", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province of China", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna Islands", "Western Sahara", "Yemen", "Yugoslavia", "Zambia", "Zimbabwe"];
var euContries = ['AT', 'BE', 'HR', 'BG', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE','IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];

$(document).ready(function(){
    $.post("https://mobisoftinfotech.com/anatoken",
        function(data) {
        
        var data1 = JSON.parse(data);
        //$('#uuid').val(data1['uuid']);
        window.contactToken = data1['anatoken'];
        //window.id = data1['id'];
        
        setTimeout(function(){ 
        $('.tokens_id').val(data1['id']);
        }, 1000);
    }
);

    $("#blog-sidebar-form").on("click", function(e) { 
        e.preventDefault();
        $(".mserror,.mserror1").hide(); 
        var name = $("#name-blog").val();
        var contact_number = $("#contact-blog").val();
        var email = $("#email-blog").val();
        var message = $("#msg-blog").val();
        var country = $("#country-blog").val(); 
        var rx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var rxPhone = "^[- 0-9*#+]*$"; 
        var formVal = 'aB#7wwclanC25ZJ9D8nHkBx@'; 
        
        
        if (name == "") { 
        $("#name-blog").nextAll('.mserror').show();
        $("#name-blog").focus();
        return;
        }
        if (email == "") {
        $("#email-blog").nextAll(".mserror").show();
        $("#email-blog").focus();
        return;
        }
        if (!rx.test(email)) {
        $("#email-blog").nextAll(".mserror1").show();
        $("#email-blog").focus();
        return;
        }
        if (contact_number == "") {
        $("#contact-blog").nextAll(".mserror").show();
        $("#contact-blog").focus();
        return;
        }
        if(!contact_number.substring(0).match(rxPhone)){
        $("#contact-blog").nextAll(".mserror1").show();
        $("#contact-blog").focus();
        return;
        } 
        if (country == "" || country == null || typeof country == undefined) { 
        $("#country-blog").nextAll('.mserror').show();
        $("#country-blog").focus();
        return false;
        }
        if(euContry === true){
        if(!$('#blog-cookies-chk1').is(':checked')){
        $('#blog-cookies-chk1').focus();
        $('.res-cookies-error').show(); 
        return false;
        }
        } 
        var tokens_id = $(".tokens_id").val();
        var uuid = window.contactToken;
        var dataString = 'email=' + email + '&contact_no=' + contact_number + '&name=' + name + '&message=' + message + '&page-url='+window.location.href + '&country='+country + '&form_field='+formVal +'&tokens_id='+ tokens_id +'&uuid='+ uuid;
        $.ajax({ 
        type: "POST",
        url: "/postcontact.php",
        data: dataString,
        success: function(response) { 
        $("input#email-blog").val('');
        $("input#name-blog").val('');
        $("input#contact-blog").val('');
        $("textarea#msg-blog").val(''); 
        window.location.href = "/thank-you.html" + referalName;
        console.log(response);
        sessionStorage.clear(); 
        }, 
        error: function(err){ 
        console.log(err);
        } 
        });
        return false;
        
        
        
        });

    $("#country").autocomplete({
        source: function (req, responseFn) {
            var re = $.ui.autocomplete.escapeRegex(req.term);
            var matcher = new RegExp("^" + re, "i");
            var a = $.grep(availableCountries, function (item, index) {
                return matcher.test(item);
            });
            responseFn(a.slice(0, 5));
        },
        open: function (event, ui) {
            $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
        },
        minLength: 1,
        appendTo: $("#country").next('.ui-countries')
    });

    $("#country1").autocomplete({
        source: function (req, responseFn) {
            var re = $.ui.autocomplete.escapeRegex(req.term);
            var matcher = new RegExp("^" + re, "i");
            var a = $.grep(availableCountries, function (item, index) {
                return matcher.test(item);
            });
            responseFn(a.slice(0, 5));
        },
        open: function (event, ui) {
            $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
        },
        minLength: 1,
        appendTo: $("#country1").next('.ui-countries')
    });

    cookiesContent();
    (function sessionCreation(){
        var url = window.location.href;
        var params = url.split('/');
        var length = params.length;             
        if(length > 0){
            sessionStorage.setItem('referenceId', params[length-1]);
        }    
    })();
    
    var referalName = sessionStorage.getItem('referenceId'); 
    if(referalName != null && referalName != "") {
        referalName = referalName.slice(0, -5);
        referalName = '?page=' + referalName       
    } else {
        referalName = '?page=home';
    }    
    
    $("input#email").val('');
    $("input#name").val('');
    $("input#contact_no").val('');
    $("textarea#message").val('');  

    var site_base_url = window.location.origin;
    //window.rd = '751269fb-e6ee-469f-a06a-e83d95356190'
    window.rd = '3cfb7812-af79-4ac9-9708-3adf7eafab28'
function encryptToken(value, secretKey) {
    return CryptoJS.AES.encrypt(value, secretKey).toString()
}

function getBrowserInfo() {
    return {
        osName: "Google's Android OS",
        osVersion: '6.0',
        browserName: 'Google Chrome',
        browserVersion: '108.0.5359.94'
    }
}

function getFormToken(formName, formData) {
    fetch(
        //'https://micontactforms-devapi.mi2.in/api/v1/create-contact-us-form-token',
        'https://contactforms-api.rainbow.health/api/v1/create-contact-us-form-token',
        {
            method: 'POST',
            body: JSON.stringify(getBrowserInfo()),
            headers: {
                'Content-type': 'application/json; charset=UTF-8'
            }
        }
    )
        .then(function (response) {
            return response.json()
        })
        .then(function (data) {
            const encryptedToken = encryptToken(data.token, window.rd)
            return submitContactUsFormData(formName, formData, encryptedToken)
        })
        .catch(error => console.error('Error:', error))
}

function submitContactUsFormData(formName, formData, encryptedToken) {
    var contactUsObj = {
        ...getBrowserInfo(),
        formData: formData,
        formName: formName,
        encryptedToken: JSON.stringify(encryptedToken)
    }

    fetch(
        //'https://contactforms-api.rainbow.health/api/v1/contact-us-forms',
        'https://contactforms-api.rainbow.health/api/v1/contact-us-form-messages',
        {
            method: 'POST',
            body: JSON.stringify(contactUsObj),
            headers: {
                'Content-type': 'application/json; charset=UTF-8'
            }
        }
    )
        .then(function (response) {
            return response.json()
        })

        .then(function (data) {
           var url_last_segment = window.location.href.split("/").pop();
            window.location.href = site_base_url + "/thank-you.html?" + url_last_segment;
           console.log('contact us submission data submitted successfully', data)

        })
        .catch(error => console.error('Error:', error))
}

     
    jQuery(function() {
        $('.mserror, .mserror1, .mserror4, .mserror5, .mserror6, .mserror7').hide();
        
        $(".send-btn").click(function(e) {
          
            var rxPhone = "^[- 0-9*#+]*$";
            e.preventDefault();
            
             $('.mserror, .mserror1, .mserror2, .mserror4').hide();
            // validate and process form here           
            var name = $.trim($("input#name").val());
            if (name === "") {
                $("input#name").nextAll('.mserror').show();
                $("input#name").focus();
                return false;
            }
            var lname = $.trim($("input#lname").val());
            if (lname === "") {
                $("input#lname").nextAll('.mserror').show();
                $("input#lname").focus();
                return false;
            }
            var email = $.trim($("input#email").val());
            if (email === "") {
                $("input#email").nextAll('.mserror').show();
                $("input#email").focus();
                return false;
            }
            var emailval = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (emailval.test(email) == false) {
                $("input#email").nextAll('.mserror1').show();
                return (false);
            }
           
            var contact_no = $.trim($("input#contact_no").val()); 
                        
            // var country = $.trim($("input#country").val()); 
            
            // if (country === "" || country == null || typeof country == undefined) {
            //     $("input#country").nextAll('.mserror').show();
            //     $("input#country").focus();
            //     return false;
            // }     
            // if (contact_no === "" || contact_no == null) {
            //     $("input#contact_no").nextAll('.mserror').show();
            //     $("input#contact_no").focus();
            //     return false;
            // }
            // var pdfUrl = $.trim($("input#pdfUrl").val()); 
            // console.log(pdfUrl)
            // if (pdfUrl !== "" || pdfUrl !== null) {
            //     window.open(pdfUrl, '_blank');
                
            // }
           
            // if(isNaN(contact_no)){
            //      $("input#contact_no").nextAll('.mserror1').show();
            //     $("input#contact_no").focus();
            //     return false;
            // }
            // if (contact_no == "") {
            //     $("#contact_no").nextAll(".mserror").show();
            //     $("#contact_no").focus();
            //     return;
            // }
            
            // if (!contact_no.substring(0).match(rxPhone)) {
            //     $("#contact_no").nextAll(".mserror1").show();
            //     $("#contact_no").focus();
            //     return;
            // }
            var contact_no = $.trim($("input#contact_no").val());
            // var company = $.trim($("input#company").val());
            // var city = $.trim($("input#city").val());
            // var state = $.trim($("input#state").val());
            // var pincode = $.trim($("input#pincode").val());
            // var service_values = $.trim($("select#service_values").val());
            var message = $.trim($("textarea#message").val());
                


            var formData = [
                {
                    fieldKey: 'firstName',
                    fieldValue: name
                },
                {
                    fieldKey: 'lastName',
                    fieldValue: lname
                },
                {
                    fieldKey: 'phone',
                    fieldValue: contact_no
                },
                {
                    fieldKey: 'businessEmail',
                    fieldValue: email
                },
                {
                    fieldKey: 'message',
                    fieldValue: message
                }
            ]
    
            var formName = 'General Contact Us'
            getFormToken(formName, formData)
            // var formVal = 'aB#7wwclanC25ZJ9D8nHkBx@';
    
            // if(euContry === true){
            //     if(!$('#cookies-chk1').is(':checked')){
            //         $('#cookies-chk1').focus();
            //         $('#cookies-chk1').parents('.form-group').find('.mserror1').show();                    
            //         return false;
            //     }
            // } 
            // var tokens_id = $(".tokens_id").val();
            // var uuid = window.contactToken;
            // var name1=name+ " " +lname;
            // var link="https://mobisoftinfotech.com/rainbowcontactmail";
            // var domainEmail="info@rainbow.health";
            // var dataString = 'email=' + email + '&contact_no=' + contact_no + '&name=' + name1 + '&company=' + company + '&city=' + city + '&state=' + state + '&pincode=' + pincode +  '&message=' + message + '&page-url='+window.location.href +  '&form_field='+formVal +'&tokens_id='+ tokens_id +'&uuid='+ uuid +'&domain-email='+ domainEmail + '&rainbowcontact=true';
            // $.ajax({            
            //     type: "POST",
            //     url: link,
            //     data: dataString,
            //     success: function(response) {                
            //         $("input#email").val('');
            //         $("input#name").val('');
            //         $("input#lname").val('');
            //         $("input#contact_no").val('');
            //         $("input#company").val('');
            //         $("input#city").val('');
            //         $("input#state").val('');
            //         $("input#pincode").val('');
            //         $("textarea#message").val('');     
            //         window.location.href = "/thank-you.html" + referalName;
            //         console.log(response);
            //         sessionStorage.clear(); 
            //     },           
            //     error: function(err){   
            //         console.log(err);
            //     }             
            // });
            return false;
        });

        $('.mserror, .mserror1, .mserror4, .mserror5, .mserror6, .mserror7').hide();
        
        $(".download-pdf-btn").click(function(e) {
            var rxPhone = "^[- 0-9*#+]*$";
            e.preventDefault();
            
             $('.mserror, .mserror1, .mserror2, .mserror4').hide();
            // validate and process form here           
            var name = $.trim($("input#name").val());
            if (name === "") {
                $("input#name").nextAll('.mserror').show();
                $("input#name").focus();
                return false;
            }
            var lname = $.trim($("input#lname").val());
            if (lname === "") {
                $("input#lname").nextAll('.mserror').show();
                $("input#lname").focus();
                return false;
            }
            var company = $.trim($("input#company").val());
            if (company === "") {
                $("input#company").nextAll('.mserror').show();
                $("input#company").focus();
                return false;
            }
            var email = $.trim($("input#email").val());
            if (email === "") {
                $("input#email").nextAll('.mserror').show();
                $("input#email").focus();
                return false;
            }
           
            var emailval = /^([\w-.]+@(?!gmail\.com)(?!yahoo\.com)(?!hotmail\.com)(?!mail\.ru)(?!yandex\.ru)(?!mail\.com)([\w-]+.)+[\w-]{2,4})?$/;
            if (emailval.test(email) == false) {
                $("input#email").nextAll('.mserror1').show();
                return (false);
            }
           
           
            var pdfUrl = $.trim($("input#pdfUrl").val()); 
            console.log(pdfUrl)
            if (pdfUrl !== "" || pdfUrl !== null) {
                window.open(pdfUrl);
                
            }
            var formData = [
                {
                    fieldKey: 'firstname',
                    fieldValue: name
                },
                {
                    fieldKey: 'lastname',
                    fieldValue: lname
                },
                {
                    fieldKey: 'organizationname',
                    fieldValue: company
                },
                {
                    fieldKey: 'businessemail',
                    fieldValue: email
                }
            ]
    
            var formName = 'White paper modal'
            getFormToken(formName, formData)
            // if (!contact_no.substring(0).match(rxPhone)) {
            //     $("#contact_no").nextAll(".mserror1").show();
            //     $("#contact_no").focus();
            //     return;
            // }
            // var message = $.trim($("textarea#message").val());
            
                
            // var formVal = 'aB#7wwclanC25ZJ9D8nHkBx@';
    
         
            // var tokens_id = $(".tokens_id").val();
            // var uuid = window.contactToken;
            // var name1=name+ " " +lname;
            // var link="https://mobisoftinfotech.com/rainbowcontactmail";
            // var domainEmail="info@rainbow.health";
            // var dataString = 'email=' + email + '&name=' + name1 + '&company=' + company + '&page-url='+window.location.href +  '&form_field='+formVal +'&tokens_id='+ tokens_id +'&uuid='+ uuid +'&domain-email='+ domainEmail + '&rainbow=true' + '&contact_no=1' + '&message=test';
            // $.ajax({            
            //     type: "POST",
            //     url: link,
            //     data: dataString,
            //     success: function(response) {                
            //         $("input#email").val('');
            //         $("input#name").val('');
            //         $("input#lname").val('');
            //         $("input#company").val('');
            //         // $("input#contact_no").val('');
            //         // $("textarea#message").val('');
            //         window.location.href = "/thank-you.html" + referalName;
            //         console.log(response);
            //         sessionStorage.clear(); 
            //     },           
            //     error: function(err){   
            //         console.log(err);
            //     }             
            // });
            return false;
        });
    }); 

    $(".form-send-btn").click(function(e) {
        var rxPhone = "^[- 0-9*#+]*$";
        e.preventDefault();

         $('.mserror, .mserror1, .mserror2').hide();
        // validate and process form here           
        var name = $.trim($("input#name1").val());
        if (name === "") {
            $("input#name1").nextAll('.mserror').show();
            $("input#name1").focus();
            return false;
        }
        var lname = $.trim($("input#lname1").val());
        if (lname === "") {
            $("input#lname1").nextAll('.mserror').show();
            $("input#lname1").focus();
            return false;
        }
        var company = $.trim($("input#company").val());
        if (company === "") {
            $("input#company").nextAll('.mserror').show();
            $("input#company").focus();
            return false;
        }
        var email = $.trim($("input#email1").val());
        if (email === "") {
            $("input#email1").nextAll('.mserror').show();
            $("input#email1").focus();
            return false;
        }
        var emailval = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (emailval.test(email) == false) {
            $("input#email1").nextAll('.mserror1').show();
            return (false);
        }
        var contact_no = $.trim($("input#contact_no1").val()); 
                    
        // var country = $.trim($("input#country1").val()); 
        
        // if (country === "" || country == null || typeof country == undefined) {
        //     $("input#country1").nextAll('.mserror5').show();
        //     $("input#country1").focus();
        //     return false;
        // }     
        if (contact_no === "" || contact_no == null) {
            $("input#contact_no1").parent().nextAll('.mserror').show();
            $("input#contact_no1").focus();
            return false;
        }
        // if(isNaN(contact_no)){
        //      $("input#contact_no1").parent().nextAll('.mserror7').show();
        //     $("input#contact_no1").focus();
        //     return false;
        // }
        if (!contact_no.substring(0).match(rxPhone)) {
            $("#contact_no1").nextAll(".mserror1").show();
            $("#contact_no1").focus();
            return;
        }
        var org_address = $.trim($("input#org_address").val());
        if (org_address === "") {
            $("input#org_address").nextAll('.mserror').show();
            $("input#org_address").focus();
            return false;
        }
        var org_type = $.trim($("select#org_type").val());

        var city = $.trim($("input#city").val());
        if (city === "") {
            $("input#city").nextAll('.mserror').show();
            $("input#city").focus();
            return false;
        }
        var state = $.trim($("input#state").val());
        if (state === "") {
            $("input#state").nextAll('.mserror').show();
            $("input#state").focus();
            return false;
        }
        var pincode = $.trim($("input#pincode").val());
        if (pincode === "") {
            $("input#pincode").nextAll('.mserror').show();
            $("input#pincode").focus();
            return false;
        }
       
        
        
        var service_values = $.trim($("select#service_values").val());
        // if (services === "") {
        //         $("select#services").nextAll('.mserror').show();
        //         var select = $("select#services");
                
        //         return false;
        //     }
       
       
       
        var message = $.trim($("textarea#message1").val());
        var formData = [
            {
                fieldKey: 'firstName',
                fieldValue: name
            },
            {
                fieldKey: 'lastName',
                fieldValue: lname
            },
            {
                fieldKey: 'phone',
                fieldValue: contact_no
            },
            {
                fieldKey: 'organizationEmail',
                fieldValue: email
            },
            {
                fieldKey: 'organizationName',
                fieldValue: company
            },
            {
                fieldKey: 'organizationType',
                fieldValue: org_type
            },
            {
                fieldKey: 'organizationAddress',
                fieldValue: org_address
            },
            {
                fieldKey: 'city',
                fieldValue: city
            },
            {
                fieldKey: 'pincode',
                fieldValue: pincode
            },
            {
                fieldKey: 'state',
                fieldValue: state
            },
            {
                fieldKey: 'services',
                fieldValue: service_values
            },
            {
                fieldKey: 'message',
                fieldValue: message
            }
        ]

        var formName = 'Inhome-care'
        getFormToken(formName, formData)
            
        // var formVal = 'aB#7wwclanC25ZJ9D8nHkBx@';

        // if(euContry === true){
        //     if(!$('#cookies-chk1').is(':checked')){
        //         $('#cookies-chk1').focus();
        //         $('#cookies-chk1').parents('.form-group').find('.mserror1').show();                    
        //         return false;
        //     }
        // } 
        // var tokens_id = $(".tokens_id").val();
        // var uuid = window.contactToken;
        // var name1=name+ " " +lname;
        // // var link="https://mobisoftinfotech.com/sendcontactmail";
        // // var domainEmail="info@rainbow.health";
        // var dataString = 'email=' + email + '&contact_no=' + contact_no + '&name=' + name1 + '&company=' + company + '&org_address=' + org_address + '&org_type=' + org_type + '&city=' + city + '&state=' + state + '&pincode=' + pincode  + '&service_values=' + service_values + '&message=' + message + '&page-url='+window.location.href +  '&form_field='+formVal +'&tokens_id='+ tokens_id +'&uuid='+ uuid;
        // $.ajax({            
        //     type: "POST",
        //     url: "https://rainbow.health/postcontact.php",
        //     data: dataString,
        //     success: function(response) {                
        //         $("input#email1").val('');
        //         $("input#name1").val('');
        //         $("input#company").val('');
        //         $("input#org_address").val('');
        //         $("input#org_type").val('');
        //         $("input#city").val('');
        //         $("input#state").val('');
        //         $("input#pincode").val('');
        //         $("input#service_values").val('');
        //         $("input#contact_no1").val('');
        //         $("textarea#message1").val('');     
        //         window.location.href = "/thank-you.html" + referalName;
        //         console.log(response);
        //         sessionStorage.clear(); 
        //     },           
        //     error: function(err){   
        //         console.log(err);
        //     }             
        // });
        return false;
    });

            
    // $('.intl-tel-input .inputMaterial').focus(function(e){
    //     $(this).parents('.group').addClass('active');
    // }).focusout(function(){
    //     if($(this).val() == ''){
    //         $(this).parents('.group').removeClass('active');
    //     }
    // });

var euContry, uCountry;

function cookiesContent(){      
    $.get('/country.php', function(resp) {
        if(resp != ""){
            uCountry = resp;
            getCont(uCountry);           
        }
    })
} 

// $("#contact_no").intlTelInput({
//     initialCountry: "auto",
//     geoIpLookup: function(callback) {
//         $.get('/country.php', function(resp) {
//             if(resp != ""){                
//                 callback(resp);
//             }
//         })
//     }
// });

function getCont(uCountry){    
    if(jQuery.inArray(uCountry, euContries) !== -1){
        euContry = true;
        

        $('.other-cookies').hide();
        
        [{
                src: 'https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.0.3/cookieconsent.min.js'
            }].forEach(function(script) {
            var x = document.createElement("script");
            x.type = 'text/javascript';
            x.async = false;
            if (script.callback)
                x.onload = script.callback;
            document.head.appendChild(x);
            x.src = script.src;
        });
        [    'https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.0.3/cookieconsent.min.css'                
        ].forEach(function(src) {
            var l = document.createElement('link');
            l.rel = 'stylesheet';
            l.href = src;
            var h = document.getElementsByTagName('head')[0];
            h.appendChild(l);
        });       

        window.addEventListener("load", function(){
            window.cookieconsent.initialise({
                "palette": {
                    "popup": {
                      "background": "#616060",
                      "text": "#ffffff"
                    },
                    "button": {
                      "background": "#4b81e8",
                      "text": "#ffffff"
                    }                                
                },                
                "content": {
                "message": "By using this site you agree to the use of cookies for analytics and personalized content.",
                "href": "rainbow.health/privacy-policy"
                }
            })
        });

    } else {
        $('.eu-cookies').hide();
}
}

});


$(function(){
    $(".int-group .inputMaterial").focus(function(){
    $(".int-group label").addClass("int-label");
    });
    
    $(".int-group .inputMaterial").focusout(function(){
        if ($(this).val().length === 0 ) {
            $(".int-group label").removeClass("int-label");
          }    
    });
});

